import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class merchantsView_template extends vnTemplate {

    protected getTemplateHtml(): string {
        return /*html*/`
            <div class="form-header">
                <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button>
                <h3 class="form-title icon i-store" data-bind="text: name"></h3>
                <div class="w-btn">
                    <button data-bind="event: { click: onClickEdit }" class="btn icon i-edit" type="button">Edit Merchant</button>
                </div>
            </div>

            <!-- Basic Information -->
            <div class="w-form-body">
                <div class="form-body">
                    <strong class="form-sub-title">Basic Information</strong>
                </div>
            </div>

            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group">
                        <dl class="double-list">
                            <dt><span>ID</span></dt>
                            <dd><span data-bind="text: id"></span></dd>

                            <dt><span>Name</span></dt>
                            <dd><span data-bind="text: name"></span></dd>

                            <dt><span>Slug</span></dt>
                            <dd class="no-cap"><span data-bind="text: slug"></span></dd>

                            <dt><span>Status</span></dt>
                            <dd>
                                <span class="status-badge" data-bind="text: isActive() ? 'Active' : 'Inactive', css: { 'active': isActive(), 'inactive': !isActive() }"></span>
                            </dd>

                            <dt><span>Special Status</span></dt>
                            <dd><span data-bind="text: specialStatusDisplay"></span></dd>
                        </dl>
                    </div>
                </div>

                <div class="form-body">
                    <div class="form-group">
                        <dl class="double-list">
                            <dt><span>Short Description</span></dt>
                            <dd class="no-cap"><span data-bind="text: blurb"></span></dd>

                            <dt><span>Full Description</span></dt>
                            <dd class="no-cap"><span data-bind="html: description"></span></dd>

                            <!-- ko if: logoImageUrl() -->
                            <dt><span>Logo</span></dt>
                            <dd>
                                <img data-bind="attr: { src: logoImageUrl }" style="max-width: 200px; max-height: 100px;" />
                            </dd>
                            <!-- /ko -->
                        </dl>
                    </div>
                </div>
            </div>

            <!-- Website & Categories -->
            <div class="w-form-body">
                <div class="form-body">
                    <strong class="form-sub-title">Website & Categories</strong>
                </div>
            </div>

            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group">
                        <dl class="double-list">
                            <!-- ko if: websiteUrl() -->
                            <dt><span>Website URL</span></dt>
                            <dd class="no-cap">
                                <a data-bind="attr: { href: websiteUrl }, text: websiteUrl" target="_blank"></a>
                            </dd>
                            <!-- /ko -->

                            <!-- ko if: websiteUrlLabel() -->
                            <dt><span>Website URL Label</span></dt>
                            <dd><span data-bind="text: websiteUrlLabel"></span></dd>
                            <!-- /ko -->

                            <dt><span>Categories</span></dt>
                            <dd><span data-bind="text: categoriesDisplay"></span></dd>
                        </dl>
                    </div>
                </div>

                <div class="form-body">
                    <div class="form-group">
                        <dl class="double-list">
                            <dt><span>Discounts Count</span></dt>
                            <dd><span data-bind="text: discountCount"></span></dd>

                            <dt><span>Date Created</span></dt>
                            <dd><span data-bind="text: dateCreated"></span></dd>

                            <dt><span>Date Updated</span></dt>
                            <dd><span data-bind="text: dateUpdated"></span></dd>
                        </dl>
                    </div>
                </div>
            </div>

            <!-- Tracking Pixels -->
            <!-- ko if: trackingPixelsDisplay() -->
            <div class="w-form-body">
                <div class="form-body">
                    <strong class="form-sub-title">Tracking Pixels</strong>
                </div>
            </div>

            <div class="w-form-body">
                <div class="form-body full-width">
                    <div class="form-group">
                        <pre data-bind="text: trackingPixelsDisplay" style="background: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"></pre>
                    </div>
                </div>
            </div>
            <!-- /ko -->
        `;
    }

    protected initPartial(): void {
        // No child templates needed
    }

    protected getTemplateName(): string {
        return "merchantsView_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): string[] {
        return ["w-form", "w-form-large"];
    }

    protected buildViewModel(): any {
        const self = this;
        return {
            id: ko.observable(""),
            name: ko.observable(""),
            slug: ko.observable(""),
            blurb: ko.observable(""),
            description: ko.observable(""),
            isActive: ko.observable(false),
            specialStatusDisplay: ko.observable(""),
            logoImageUrl: ko.observable(""),
            websiteUrl: ko.observable(""),
            websiteUrlLabel: ko.observable(""),
            categoriesDisplay: ko.observable(""),
            discountCount: ko.observable(0),
            trackingPixelsDisplay: ko.observable(""),
            dateCreated: ko.observable(""),
            dateUpdated: ko.observable(""),

            onClickEdit: (data, event) => {
                self.onClickEdit();
            },
            onClickCancel: (data, event) => {
                self.onClickCancel();
            }
        };
    }

    public setMerchantData(merchant: any): void {
        const vm = this.getTemplateViewModel();

        vm.id(merchant.id);
        vm.name(merchant.name || '');
        vm.slug(merchant.slug || '');
        vm.blurb(merchant.blurb || '');
        vm.description(merchant.description || '');
        vm.isActive(merchant.isActive !== false);
        vm.websiteUrl(merchant.websiteUrl || '');
        vm.websiteUrlLabel(merchant.websiteUrlLabel || '');
        vm.dateCreated(merchant.dateCreated ? merchant.dateCreated.substring(0, 10) : '');
        vm.dateUpdated(merchant.dateUpdated ? merchant.dateUpdated.substring(0, 10) : '');

        // Special status
        if (merchant.specialStatus) {
            const label = merchant.specialStatus.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
            vm.specialStatusDisplay(label);
        } else {
            vm.specialStatusDisplay('None');
        }

        // Categories
        if (merchant.categories && merchant.categories.length > 0) {
            vm.categoriesDisplay(merchant.categories.map(c => c.name).join(', '));
        } else {
            vm.categoriesDisplay('None');
        }

        // Discounts count
        if (merchant.discounts) {
            vm.discountCount(merchant.discounts.length);
        } else {
            vm.discountCount(0);
        }

        // Image
        if (merchant.image) {
            vm.logoImageUrl(merchant.image.url);
        }

        // Tracking pixels
        if (merchant.trackingPixels && merchant.trackingPixels.length > 0) {
            vm.trackingPixelsDisplay(JSON.stringify(merchant.trackingPixels, null, 2));
        } else {
            vm.trackingPixelsDisplay('');
        }
    }

    protected onClickEdit(): void {
        const id = this.getTemplateViewModel().id();
        this.caller.onClickEditMerchant(id);
    }

    protected onClickCancel(): void {
        this.caller.onClickCancel();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/merchantsView_template.ts